import { gql } from "@apollo/client";

export const GET_ALL_CATEGORIES = gql`
	query GetCategories {
		categories(first: 100000) {
			edges {
				node {
					id
					name
					uri
					slug
				}
			}
		}
	}
`;
